import React, { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom';
import { FaUserTie } from "react-icons/fa6";
import { FaRegCalendarCheck } from "react-icons/fa6";
import { FaWallet } from "react-icons/fa";
import profileimage from './Anonymous.png'
import Account from './account';
import themeApi from '../../darkmode/themecontext';
import { MdLightMode } from "react-icons/md";
import { MdOutlineDarkMode } from "react-icons/md";
import { FaMoneyCheckAlt } from "react-icons/fa";
import axios from 'axios';
import AdminBanner from './AdminBanner';
const api = process.env.REACT_APP_API_BASE;

/**
 * Decode JWT Token to extract payload (as used in ClientList.jsx)
 */
function decodeToken(token) {
    if (!token) return {};
    try {
        const base64Url = token.split('.')[1]
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join('')
        );
        return JSON.parse(jsonPayload);
    } catch (e) {
        return {};
    }
}

// Prefer using the same mechanism as in ClientList.jsx to get userId
function getUserIdFromTokenOrLocatorgarsotrga() {
    // Try global locatorgarsotrga if available
    if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
        const rawToken = window.locatorgarsotrga("token");
        if (rawToken) {
            const decoded = decodeToken(rawToken);
            const userId = decoded.id || decoded.userId || decoded._id;
            return { userId, token: rawToken };
        }
    }
    // Fallback to localStorage (if locatorgarsotrga is not set)
    const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    if (rawToken) {
        const decoded = decodeToken(rawToken);
        const userId = decoded.id || decoded.userId || decoded._id;
        return { userId, token: rawToken };
    }
    return { userId: null, token: null };
}

function Header() {
    const { themMode, darkMode, lightMode } = useContext(themeApi);
    const [showAccount, setshowaccount] = useState(false)
    const [showwallet, setshowwallet] = useState(false)
    const[balance, setBalance] = useState();
  
    // State for the logged-in user's data
    const [user, setUser] = useState(null);

    useEffect(() => {
        const { userId, token } = getUserIdFromTokenOrLocatorgarsotrga();

        if (userId && token) {
            fetch('https://wa-api.globebot.io/auth/allusersinfo', {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            })
                .then(res => res.json())
                .then(data => {
                    if (Array.isArray(data)) {
                        const found = data.find(u => String(u.id) === String(userId));
                        setUser(found || null);
                    }
                })
                .catch(err => {
                    console.error('Could not fetch user data', err);
                });
        }
    }, []);
    useEffect(() => {

        if (!user?.email) return;
    
        const fetchBalance = async () => {
    
            try {
    
                const formData = new FormData();
    
                formData.append("email", user.email);
    
                const response = await fetch(
                    `${api}/auth/extapi/wallet-balance`,
                    {
                        method: "POST",
                        body: formData,
                    }
                );
    
                const data = await response.json();
    
                console.log(data);
    
                if (data.status) {
                    setBalance(data.data.wallet_balance);
                }
    
            } catch (error) {
                console.error(error);
            }
        };
    
        fetchBalance();
    
    }, [user]);

    const displayProfileImage = (user && user.profile && user.profile !== "/uploads/null")
        ? (`${api}${user.profile}`)
   
        : profileimage;

    const displayUserName = user?.name || "Unknown";

    return (
        <>
    
            <header className='bg-[#f4f4f4] dark:bg-[#121519] py-2 px-4 flex flex-wrap md:flex-nowrap justify-between items-center gap-2 shadow-[rgba(0,0,0,0.1)_0px_18px_18px_-5px,rgba(0,0,0,0.04)_0px_0px_0px_-7px] fixed w-[100%] top-0 z-20 dark:border-b-[1px] dark:border-[#e9eef33b] ' >

                <h1 className='text-[#000] font-bold text-[16px] md:text-[18px] break-all [text-shadow:1px_1px_#9571ee] dark:text-[#fff]'>
                    <Link to='/'>Globebot</Link>
                </h1>

                <div className='flex flex-wrap items-center justify-end gap-2 md:gap-0'>
                    {(user?.role === 'super_admin' || user?.role === 'admin' || user?.role === 'reseller') && (
                        <>
                            <Link to='/AdminHome'>
                                <div className='flex justify-center items-center text-[#6f6f6f] px-[15px] md:px-[20px] py-[5px] rounded-[0.5em] bg-[#e8e8e8] border border-[#e8e8e8] font-bold md:mr-[10px] cursor-pointer transition-all duration-300 shadow-[4px_4px_5px_#c5c5c5,2px_-1px_0px_#ffffff] gap-1 dark:text-[#e2dbdb] dark:bg-[#323030] dark:border-[#251f1f] dark:shadow-[4px_4px_5px_#423a3a,2px_-1px_0px_#584f4f]'>
                                    <FaUserTie />
                                    <span className='text-[12px]'>Admin</span>
                                </div>
                            </Link>
                            <Link to='/approval'>
                                <div className='flex justify-center items-center text-[#6f6f6f] px-[15px] md:px-[20px] py-[5px] rounded-[0.5em] bg-[#e8e8e8] border border-[#e8e8e8] font-bold md:mr-[10px] cursor-pointer transition-all duration-300 shadow-[4px_4px_5px_#c5c5c5,2px_-1px_0px_#ffffff] gap-1 dark:text-[#e2dbdb] dark:bg-[#323030] dark:border-[#251f1f] dark:shadow-[4px_4px_5px_#423a3a,2px_-1px_0px_#584f4f]'>
                                    <FaRegCalendarCheck />
                                    <span className='text-[12px]'>Approval</span>
                                </div>
                            </Link>
                        </>
                    )}
               
                    <div
                        onClick={() => {
                            setshowwallet(!showwallet)
                        }}
                        className='flex justify-center items-center text-[#6f6f6f] px-[15px] md:px-[20px] py-[5px] rounded-[0.5em] bg-[#e8e8e8] border border-[#e8e8e8] font-bold md:mr-[10px] cursor-pointer transition-all duration-300 shadow-[4px_4px_5px_#c5c5c5,2px_-1px_0px_#ffffff] gap-1 dark:text-[#e2dbdb] dark:bg-[#323030] dark:border-[#251f1f] dark:shadow-[4px_4px_5px_#423a3a,2px_-1px_0px_#584f4f] relative'>
                        <FaWallet />
                        {showwallet ?
                            <div className='bg-[#fff] w-[170px] p-2  absolute bottom-[-60px] right-[0] z-50 border-[1px] border-[#3f7fc86b] rounded-lg dark:bg-[#121519]'>
                                <p className='text-[10px] text-[#3f7fc8] flex items-center gap-1'>
                                    <FaMoneyCheckAlt />
                                    Wallet Balance: ₹{user?.wallet || 0}
                                </p>
                                
                            </div>
                            : ""
                        }
                    </div>

                    <div
                        onMouseEnter={() => setshowaccount(true)}
                        onMouseLeave={() => setshowaccount(false)}
                        className='relative flex items-center cursor-pointer gap-1 ml-2 md:ml-4'
                    >
                        <img
                            className='w-8 h-8 rounded-full border-[1px] border-[#e3e9ef]'
                            src={displayProfileImage}
                            alt=""
                        />

                        <h1 className='text-[14px] md:text-[16px] font-bold text-[#61748f] hover:text-[#448c74]'>
                            {displayUserName}
                        </h1>

                        {showAccount && <Account user={user} />}
                    </div>
                </div>

                {!(window?.location?.pathname?.startsWith('/developer/console')) && (
                    <button
                        onClick={themMode === 'light' ? darkMode : lightMode}
                        className="dark:bg-black bg-white dark:text-black text-white p-2 rounded-[40px] fixed top-[60px] right-[5px] border-[.5px] border-[#e3e9ef] z-20"
                    >
                        <MdLightMode className='text-[#448c74] animate-spin  ' />
                    <div className="h-[30px] w-[15px] rounded-[40px] flex justify-center p-[2px] bg-[#448c74]">
                        <div
                            className={`w-[10px] h-[10px] bg-white rounded-full transform transition-all duration-300 ease-in-out ${themMode === 'light' ? 'translate-y-0' : 'translate-y-[14px]'
                                }`}
                        ></div>
                    </div>
                    <MdOutlineDarkMode className='text-[#448c74]' />
                </button>
                )}
           
                    
            </header>
        </>
    )
}

export default Header
